import { createReducer } from './create';

const initialState = {
    is_loading_food: false,
    food: null,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: () => {
        return initialState;
    },
    ['APP/GO_TO_STEP_1']: state => {
        return {
            ...state,
            is_loading_food: false,
            food: null,
        };
    },
    ['FOOD/LOAD']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_food: true,
        });
    },
    ['FOOD/LOAD_FINISHED']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_food: false,
            food: payload.food,
        });
    },
});
